'use client'

import {
  Toaster as ChakraToaster,
  Portal,
  Spinner,
  Stack,
  Toast,
  createToaster,
} from '@chakra-ui/react'

export const toaster = createToaster({
  placement: 'bottom-start',
  pauseOnPageIdle: true,
})

function _optionalChain(ops) {
  let lastAccessLHS = undefined
  let value = ops[0]
  let i = 1
  while (i < ops.length) {
    const op = ops[i]
    const fn = ops[i + 1]
    i += 2
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      return undefined
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value
      value = fn(value)
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => value.call(lastAccessLHS, ...args))
      lastAccessLHS = undefined
    }
  }
  return value
};


export const Toaster = () => {
  return (
    <Portal>
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {(toast) => {
          let bg, border, color;
          switch (toast.type) {
            case 'success':
              bg = '#e6f9ed';
              border = '1px solid #38a169';
              color = '#22543d';
              break;
            case 'error':
              bg = '#ffeaea';
              border = '1px solid #e53e3e';
              color = '#742a2a';
              break;
            case 'warning':
              bg = '#fffbe6';
              border = '1px solid #d69e2e';
              color = '#744210';
              break;
            case 'info':
              bg = '#e6f6ff';
              border = '1px solid #3182ce';
              color = '#2a4365';
              break;
            case 'loading':
              bg = '#f7fafc';
              border = '1px solid #a0aec0';
              color = '#2d3748';
              break;
            default:
              bg = '#f7fafc';
              border = '1px solid #cbd5e0';
              color = '#2d3748';
          }
          return (
            <Toast.Root width={{ md: 'sm' }} style={{ background: bg, border, color }}>
              {toast.type === 'loading' ? (
                <Spinner size='sm' color='blue.solid' />
              ) : (
                <Toast.Indicator />
              )}
              <Stack gap='1' flex='1' maxWidth='100%'>
                {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
                {toast.description && (
                  <Toast.Description>{toast.description}</Toast.Description>
                )}
              </Stack>
              {toast.action && (
                <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
              )}
              {_optionalChain([
                toast,
                'access',
                (_) => _.meta,
                'optionalAccess',
                (_2) => _2.closable,
              ]) && <Toast.CloseTrigger />}
            </Toast.Root>
          );
        }}
      </ChakraToaster>
    </Portal>
  )
}
